<template>
    <v-toolbar color="primary" fixed dark app >
        </v-toolbar-title>
            <v-toolbar-side-icon @click.stop="handleDrawerToggle"></v-toolbar-side-icon>
            <v-spacer></v-spacer>
            <v-btn icon @click="handleFullScreen()">
                <v-icon>fullscreen</v-icon>
            </v-btn>
            <v-menu offset-y origin="center center" :nudge-bottom="10" transition="scale-transition">
                <v-btn small flat slot="activator">
                    {{ typeof user === 'object' && user !== null ? user.email : '' }}
                </v-btn>
                <v-list class="pa-0">
                    <v-list-tile v-for="(item,index) in items" :to="!item.href ? { name: item.name } : null" :href="item.href" @click.prevent="item.click" ripple="ripple" :disabled="item.disabled" :target="item.target" rel="noopener" :key="index">
                        <v-list-tile-action v-if="item.icon">
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                    <SenhaModal />
                    <v-list-tile href="#" @click.prevent="logout" ripple="ripple" rel="noopener" :key="items.lenght">
                        <v-list-tile-action>
                            <v-icon>logout</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                            <v-list-tile-title>Sair</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </v-list>
            </v-menu>
    </v-toolbar>
</template>

<script>
    import SenhaModal   from '@/views/usuarios/SenhaModal';
    import Util         from '@/util';
    import { userKey  } from '@/global';
    import { mapState } from 'vuex';

    export default {
        name       : 'app-toolbar',
        components : {
            SenhaModal
        },
        data       : () => ({
            items : [],
        }),
        computed   : {
            ...mapState(['user']),
            toolbarColor() {
                return this.$vuetify.options.extra.mainNav;
            }
        },
        methods    : {
            handleDrawerToggle() {
                window.getApp.$emit('APP_DRAWER_TOGGLED');
            },
            handleFullScreen() {
                Util.toggleFullScreen();
            },
            logout() {
                // console.log('Logout disparado...');
                localStorage.removeItem(userKey);
                this.$store.commit('setUser', null);
                window.getApp.$emit('APP_LOGOUT');
            }
        }
    };
</script>
